// extracted by mini-css-extract-plugin
export default {"item":"ContactsItem_item__pedOi"};